import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import PageHeader from '../../../components/base/PageHeader/PageHeader';
import {
  Button, Icons,
} from '../../../components/base/BootstrapComponents';
import TabMenu from '../../../components/base/TabMenu/TabMenu';
import TextInput from '../../../components/fields/TextInput/TextInput';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldWithAttributeDTO from '../../../components/fields/Abstract/FieldWithAttributeDTO';
import CustomSelectInput from '../../../components/fields/SelectInput/CustomSelectInput';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import { optionClassFormatter } from '../../../utils/formatters';
import {
  getJSONFromString,
  getPaginationOpts, responseLogWithNotification, saveFilter, useSortData,
} from '../../../utils/utils';
import Loader from '../../../components/base/Loader/Loader';
import { getParkingMetersData } from '../../ParkingMeter/reducer';
import { convertMetricFilters, sortByStatus } from '../camera-utils';
import { loadCamerasList, loadCamerasStatusesList } from '../actions';
import CameraFilter from './CameraFilter';
import MatrixReportPopup from './MatrixReportPopup';
import CamerasGrid from './CamerasGrid';
import CamerasMap from './CamerasMap';
import CamerasMatrix from './CamerasMatrix';
import CamerasHistoryPopup from './CamerasHistoryPopup';
import HelperTooltip from './HelperTooltip';
import { cMetricKeys, CAMERA_STATUS } from '../constants';
import { getCamerasData } from '../reducer';
import CameraDTO from '../../../dto/CameraDTO';

const tabOptions = [
  { value: 0, label: 'Таблица' },
  { value: 1, label: 'Карта' },
  { value: 2, label: 'Матрица' },
];

const updatePeriods = [
  { value: 0, name: 'Не обновлять' },
  { value: 10, name: '10 секунд' },
  { value: 30, name: '30 секунд' },
  { value: 60, name: '1 минута' },
  { value: 300, name: '5 минут' },
];

export default function CamerasPage() {
  const {
    loadingHostComponents,
    showHistoryPopup,
    currentParkingMeter,
    loadingHostCommandDispatch,
    loadingHostDetail,
    hostDetail,
    loadingHistoryExportWord,
    zones,
    loadingZones,
  } = useSelector(getParkingMetersData);
  const {
    loadingCamerasList,
    camerasList,
    camerasListMeta,
    loadingCamerasStatusesList,
    camerasStatusesList,
    camerasStatusesListMeta,
  } = useSelector(getCamerasData);

  const dispatch = useDispatch();
  const handleLoadingCamerasList = opts => {
    const filterData = getValues();
    let sortData = [...sort];
    if (opts && !opts.page) {
      opts.page = 1;
    }
    if (opts && opts.sortData) {
      sortData = [...opts.sortData];
    }
    Object.keys(filterData).forEach(key => {
      if (!filterData[key]) {
        delete filterData[key];
      }
    });
    saveFilter(filterData, 'cameras-filter');
    if (filterData) {
      convertMetricFilters(filterData);
    }
    const paginationOpts = getPaginationOpts(camerasListMeta, opts);
    const requestData = {
      metricKeys: cMetricKeys,
      ...paginationOpts,
      filter: filterData,
      sort: sortData.join(','),
    };
    const selectedTab = getTab();
    const action = !selectedTab || !selectedTab.value
      ? loadCamerasList
      : loadCamerasStatusesList;
    if (currentTimeOut) {
      clearTimeout(currentTimeOut);
    }
    if (window.location.pathname === '/cameras') {
      dispatch(action(requestData)).catch(responseLogWithNotification).finally(() => {
        if (updatePeriod) {
          const t = setTimeout(() => handleLoadingCamerasList(opts), updatePeriod * 1000);
          clearTimeout(window.parkingMetreTimeOut);
          window.parkingMetreTimeOut = t;
        }
      });
    }
  };
  const intl = useIntl();

  const { formatMessage } = intl;
  const getTab = () => getJSONFromString(window.localStorage.getItem('parking-meter-tab')) || tabOptions[0];
  const saveTab = value => {
    window.localStorage.setItem('parking-meter-tab', JSON.stringify(value));
    setTab(value);
  };
  const [selectedTab, setTab] = useState(getTab());
  const [zoom, setZoom] = useState(10);
  const [isCenter, setIsCenter] = useState(false);
  const [selectedHost, setHost] = useState(null);
  const [isOpenFilter, setOpenFilter] = useState(false);
  const [fullScreen, setFullScreenMap] = useState(false);
  const defaultValues = {
    query: '',
    name: '',
    status: null,
    address: '',
    zbx_zone: '',
    update_period: 0,
    available_status: null,
    DS_ERROR: false,
    DS_NO_INIT_DETECT_VIOLATION: false,
    DS_NO_INIT_DETECTION: false,
    DS_NO_INIT_CAMERA: false,
    DS_UNKNOWN: false,
    DS_OK: false,
    PRS_NO: false,
    PRS_UNKNOWN: false,
    PRS_YES: false,
  };

  const {
    register, watch, getValues, setValue, reset, resetField,
  } = useForm({
    defaultValues: { ...defaultValues, ...(JSON.parse(localStorage.getItem('cameras-filter')) || {}) },
  });

  watch();

  useEffect(() => {
    const subscription = watch(value => {
      if (!getValues('update_period')) {
        setUpdatePeriod(0);
      }
      handleLoadingCamerasList();
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const [updatePeriod, setUpdatePeriod] = useState(0 || getValues('update_period'));
  const [currentTimeOut, setCurrentTimeOut] = useState(null);
  const [showMatrixReport, setShowMatrixReport] = useState(false);
  useEffect(() => { handleLoadingCamerasList(); return () => { clearTimeout(window.parkingMetreTimeOut); }; }, [updatePeriod]);
  useEffect(() => handleLoadingCamerasList({ page: 1 }), [selectedTab]);

  const formData = getValues();

  const { changeSort, sort } = useSortData('', handleLoadingCamerasList, 'camera-sort');
  const statusOptions = Object.values(CAMERA_STATUS).map(v => ({ value: Number(v), nameId: `cameras.status.${v}` })).reverse();
  const DTO = new CameraDTO();
  const attributes = DTO.getAttributesByName();
  const triggerFullScreen = value => setFullScreenMap(value);

  const sortedCamerasStatusesList = camerasStatusesList.sort(sortByStatus);

  const showOnMap = item => {
    saveTab(tabOptions[1]);
    setHost(item);
  };

  const filterCount = Object.keys(formData).filter(key => formData[key]).length;

  return (
    <div className={classNames('parking-meters-page content g-0 pb-4', { 'page-with-map-fullscreen': fullScreen })}>
      <Loader global loading={loadingZones || loadingCamerasList || loadingHostComponents || loadingHostCommandDispatch || loadingCamerasStatusesList || loadingHostDetail || loadingHistoryExportWord} />
      <PageHeader header="Информация о видеокамерах">
        <TabMenu
          selectedTab={selectedTab}
          options={tabOptions}
          onSelectOptions={item => { saveTab(item); setHost(null); }}
        />
      </PageHeader>
      <FilterRow className="filter-row">
        <div className="parking-meter-helper">
          <Tooltip
            tooltipContent={<HelperTooltip />}
            content={<Icons customIcon icon="help-outline" className="parking-meter-helper-icon" />}
          />
        </div>
        <CustomSelectInput
          label="Период обновления"
          placeholder="Период обновления"
          dtoObject={attributes.status}
          inputProps={{
            value: getValues('update_period'),
            ...register('update_period'),
            onChange: event => { setValue('update_period', event.target.value || 0); setUpdatePeriod(event.target.value || 0); },
          }}
          className="small parking-meter-state-select no-border"
          options={updatePeriods}
        />
        <FieldWithAttributeDTO
          inputBefore={<Icons customIcon className="search-icon" width={24} height={17} icon="search" />}
          type="text"
          component={TextInput}
          dtoObject={{
            name: 'query',
            type: String,
            validators: [],
            labelKey: 'search',
          }}
          inputProps={{
            ...register('query', { maxLength: 30 }),
            value: getValues('query'),
          }}
          className="small no-border search-field"
        />
        <FieldWithAttributeDTO
          type="text"
          component={TextInput}
          dtoObject={attributes.name}
          inputProps={{
            ...register('name'),
            value: getValues('name'),
          }}
          className="small no-border host-filter"
        />
        <FieldWithAttributeDTO
          type="text"
          component={CustomSelectInput}
          dtoObject={attributes.status}
          inputProps={{
            value: Number(getValues('status')),
            onChange: e => {
              setValue('status', e.target.value);
            },
          }}
          className="small parking-meter-state-select no-border status-filter"
          options={statusOptions}
          addPlaceholder
          inputClassName={optionClassFormatter(getValues('status') || 0)}
          renderOption={item => (
            <div className={optionClassFormatter(item)}>
              {!item.name && item.nameId ? formatMessage({ id: item.nameId }) : item.name || ''}
            </div>
          )}
        />
        <Button className="filter-button" onClick={() => { setOpenFilter(true); setHost(null); }}>
          <Icons width={15} height={15} customIcon icon="filter" className="button-icons" />
          Все фильтры
          {filterCount ? <div className="filter-count">{filterCount}</div> : null}
        </Button>
        {selectedTab && selectedTab.value === 2 ? <Button className="export-button" onClick={() => setShowMatrixReport(true)}>Сформировать отчёт</Button> : null}
        {isOpenFilter
          ? (
            <CameraFilter
              meta={!selectedTab || !selectedTab.value ? camerasListMeta : camerasStatusesListMeta}
              reset={reset}
              onHide={() => { setOpenFilter(false); }}
              register={register}
              getValues={getValues}
              setValue={setValue}
              resetField={resetField}
              zones={zones}
              defaultValues={defaultValues}
            />
          )
          : null}
      </FilterRow>
      {selectedTab && selectedTab.value === 0 ? <CamerasGrid sort={sort} changeSort={changeSort} loading={loadingCamerasList} showOnMap={showOnMap} camerasList={camerasList} handleLoadingCamerasList={handleLoadingCamerasList} camerasListMeta={camerasListMeta} /> : null}
      {selectedTab && selectedTab.value === 1 && window.yandexMap ? <CamerasMap selectedHost={selectedHost} hostDetail={hostDetail} setHost={setHost} triggerFullScreen={triggerFullScreen} camerasStatusesList={camerasStatusesList} handleLoadingCamerasList={handleLoadingCamerasList} camerasListMeta={camerasListMeta} zoom={zoom} setZoom={setZoom} isCenter={isCenter} setIsCenter={setIsCenter} /> : null}
      {selectedTab && selectedTab.value === 2 ? <CamerasMatrix hostDetail={hostDetail} camerasStatusesList={camerasStatusesList} handleLoadingCamerasList={handleLoadingCamerasList} camerasListMeta={camerasListMeta} /> : null}
      {showHistoryPopup && currentParkingMeter ? <CamerasHistoryPopup /> : null}
      {showMatrixReport && sortedCamerasStatusesList ? <MatrixReportPopup sortedHostStatusesList={sortedCamerasStatusesList} handleClose={() => setShowMatrixReport(false)} /> : null}
    </div>
  );
}
